"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableBody = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _TableHeaderCell = require("../TableHeaderCell/TableHeaderCell.context");
var _TableBody = require("./TableBody.styles");
/**
 * A native [`<tbody>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/tbody) element.
 *
 * @since 8.0.0
 */

var TableBody = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  return /*#__PURE__*/_react.default.createElement(_TableHeaderCell.TableHeaderCellProvider, {
    value: {
      parent: 'body'
    }
  }, /*#__PURE__*/_react.default.createElement(_TableBody.StyledTableBody, (0, _extends2.default)({
    ref: forwardedRef
  }, props)));
});
exports.TableBody = TableBody;
TableBody.displayName = 'Table.Body';